var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZipfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M494.479 138.557 364.04 3.018A9.853 9.853 0 0 0 356.945 0h-194.41c-21.757 0-39.458 17.694-39.458 39.442v137.789H44.29c-16.278 0-29.521 13.239-29.521 29.513v147.744C14.769 370.761 28.012 384 44.29 384h78.787v88.627c0 21.71 17.701 39.373 39.458 39.373h295.238c21.757 0 39.458-17.653 39.458-39.351V145.385a9.85 9.85 0 0 0-2.752-6.828zM359.385 26.581l107.079 111.265H359.385V26.581zM44.29 364.308c-5.42 0-9.828-4.405-9.828-9.82V206.744c0-5.415 4.409-9.821 9.828-9.821h265.881c5.419 0 9.829 4.406 9.829 9.821v147.744c0 5.415-4.41 9.82-9.829 9.82H44.29zm433.248 108.341c0 10.84-8.867 19.659-19.766 19.659H162.535c-10.899 0-19.766-8.828-19.766-19.68V384H310.17c16.279 0 29.522-13.239 29.522-29.512V206.744c0-16.274-13.243-29.513-29.522-29.513H142.769V39.442c0-10.891 8.867-19.75 19.766-19.75h177.157v128c0 5.438 4.409 9.846 9.846 9.846h128v315.111z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.785 240.345h17.076v84.578h-17.076zM115.405 310.673l46.325-57.058v-13.268H99.828v14.306h39.402l-44.421 54.866v15.404h68.711v-14.25zM267.02 249.895c-3.272-4.251-7.328-7.01-12.175-8.281-3.153-.847-9.922-1.267-20.308-1.267h-27.405v84.576h17.078v-31.904h11.133c7.732 0 13.634-.404 17.713-1.211 2.998-.655 5.952-1.992 8.854-4.01 2.905-2.019 5.3-4.798 7.183-8.337 1.886-3.537 2.828-7.904 2.828-13.096.002-6.729-1.632-12.221-4.901-16.47zm-14.626 23.279c-1.288 1.883-3.067 3.269-5.337 4.153-2.27.883-6.769 1.326-13.499 1.326h-9.346v-24h8.249c6.156 0 10.252.192 12.29.576 2.769.502 5.056 1.75 6.865 3.751 1.807 1.999 2.71 4.539 2.71 7.616 0 2.499-.642 4.692-1.932 6.578z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipfile);
export default __webpack_public_path__ + "static/media/zipfile.e516332bdc0b67f50a16572f1344f503.svg";
export { ForwardRef as ReactComponent };